export const TEXT_TYPE = "text";
export const PASS_TYPE = "password";
